import { BasketMessage, CalendarStar, ClockIcon, Discount, RocketIcon, Sale, Thunder, Torch } from 'assets/icons'
import { SYSTEM_CONTEXT_IDS } from 'modules/niche/common/niche.consts'
import type { DefaultContext } from 'modules/niche/common/types'

import { translations } from './use-brand-niche-context-manager.i18n'
import type { TBrandContentType } from '../../brands.types'

const BRAND_TOTAL_CONTEXTS: DefaultContext[] = [
  {
    id: SYSTEM_CONTEXT_IDS.mostEngaged,
    name: '',
    translation: translations.mostEngaged,
    icon: <RocketIcon />,
    hash: null,
  },
  {
    id: SYSTEM_CONTEXT_IDS.happeningNow,
    name: '',
    translation: translations.happeningNow,
    icon: <ClockIcon />,
    hash: null,
  },
  {
    id: SYSTEM_CONTEXT_IDS.launches,
    name: '',
    translation: translations.launches,
    icon: <Discount />,
    hash: null,
  },
  {
    id: SYSTEM_CONTEXT_IDS.trendingProducts,
    name: '',
    translation: translations.trendingProducts,
    icon: <BasketMessage />,
    hash: null,
  },
  {
    id: SYSTEM_CONTEXT_IDS.painPoints,
    name: '',
    translation: translations.painPoints,
    icon: <Thunder />,
    hash: null,
  },
  {
    id: SYSTEM_CONTEXT_IDS.paidPartnership,
    name: '',
    translation: translations.paidPartnerships,
    icon: <Torch />,
    hash: null,
  },
]

const BRAND_OWNED_CONTEXTS: DefaultContext[] = [
  {
    id: SYSTEM_CONTEXT_IDS.mostEngaged,
    name: '',
    translation: translations.mostEngaged,
    icon: <RocketIcon />,
    hash: null,
  },
  {
    id: SYSTEM_CONTEXT_IDS.happeningNow,
    name: '',
    translation: translations.happeningNow,
    icon: <ClockIcon />,
    hash: null,
  },
  {
    id: SYSTEM_CONTEXT_IDS.launches,
    name: '',
    translation: translations.launches,
    icon: <Discount />,
    hash: null,
  },
  {
    id: SYSTEM_CONTEXT_IDS.promotionsDiscounts,
    name: '',
    translation: translations.promotionsDiscounts,
    icon: <Sale />,
    hash: null,
  },
]

const BRAND_EARNED_CONTEXTS: DefaultContext[] = [
  {
    id: SYSTEM_CONTEXT_IDS.mostEngaged,
    name: '',
    translation: translations.mostEngaged,
    icon: <RocketIcon />,
    hash: null,
  },
  {
    id: SYSTEM_CONTEXT_IDS.happeningNow,
    name: '',
    translation: translations.happeningNow,
    icon: <ClockIcon />,
    hash: null,
  },
  {
    id: SYSTEM_CONTEXT_IDS.trendingProducts,
    name: '',
    translation: translations.trendingProducts,
    icon: <BasketMessage />,
    hash: null,
  },
  {
    id: SYSTEM_CONTEXT_IDS.painPoints,
    name: '',
    translation: translations.painPoints,
    icon: <Thunder />,
    hash: null,
  },
]

const BRAND_PAID_CONTEXTS: DefaultContext[] = [
  {
    id: SYSTEM_CONTEXT_IDS.mostEngaged,
    name: '',
    translation: translations.mostEngaged,
    icon: <RocketIcon />,
    hash: null,
  },
  {
    id: SYSTEM_CONTEXT_IDS.happeningNow,
    name: '',
    translation: translations.happeningNow,
    icon: <ClockIcon />,
    hash: null,
  },
  {
    id: SYSTEM_CONTEXT_IDS.paidPartnership,
    name: '',
    translation: translations.paidPartnerships,
    icon: <Torch />,
    hash: null,
  },
  {
    id: SYSTEM_CONTEXT_IDS.sponsoredEvents,
    name: '',
    translation: translations.sponsoredEvents,
    icon: <CalendarStar />,
    hash: null,
  },
]

export const BRAND_CONTEXTS_BY_TYPE: Record<TBrandContentType, DefaultContext[]> = {
  total: BRAND_TOTAL_CONTEXTS,
  owned: BRAND_OWNED_CONTEXTS,
  earned: BRAND_EARNED_CONTEXTS,
  paid: BRAND_PAID_CONTEXTS,
}
